import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

interface IFlatButtonProps extends ButtonProps {
  variant?: 'contained' | 'outlined';
  isicon?: 'true';
  width?: string;
  height?: string;
}

export const StyledFlatButton = styled(Button)<IFlatButtonProps>(
  ({ theme, variant, isicon, width, height }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: isicon ? '123px' : width ? width : '164px',
    height: isicon ? '44px' : height ? height : '43px',
    fontSize: isicon ? '16px' : '14px',
    fontWeight: 400,
    lineHeight: isicon ? '24px' : '21px',
    letterSpacing: isicon ? '-0.352px' : '-0.308px',
    borderRadius: '4px',
    border: 'none',
    color:
      variant === 'contained'
        ? theme.palette.common.white
        : theme.palette.secondary.light,
    background:
      variant === 'contained'
        ? theme.palette.primary.main
        : theme.palette.action.disabled,
    '&:hover': {
      border: 'none',
      color:
        variant === 'contained'
          ? theme.palette.common.white
          : theme.palette.secondary.light,
      background:
        variant === 'contained'
          ? theme.palette.primary.main
          : theme.palette.action.disabled,
    },
  })
);
